export const ADD_CLASS_REQUEST = 'ADD_CLASS_REQUEST'
export const ADD_CLASS_SUCCESS = 'ADD_CLASS_SUCCESS'
export const ADD_CLASS_FALIURE = 'ADD_CLASS_FALIURE'
